
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Inventory, InventoryUiClient } from '../../../backend/backendapi';
import { initClient } from '../../../../api';

@Component({
  name: 'InventoryDeleteModal',
})
export default class InventoryDeleteModal extends Vue {
  inventories: Inventory[] = [];

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(inventories: Inventory[]): void {
    this.inventories = inventories;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  deleteSelected(): void {
    if (!this.inventories.length) {
      return;
    }
    this.service.deleteData(this.inventories)
        .then(_ => {
          this.$toasted.info(this.$t('txtDeleted').toString());
          this.$emit('deleted');
          this.dismiss();
        })
        .catch(e => this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e)));
  }
}
